var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: { "svg-icon-auto": _vm.auto, "svg-icon-limit": !_vm.auto },
      on: {
        click: function ($event) {
          return _vm.$emit("click")
        },
      },
    },
    [
      _vm.tooltip
        ? _c(
            "el-tooltip",
            { attrs: { content: _vm.content, placement: _vm.placement } },
            [
              _c(
                "svg",
                { class: _vm.svgClass, attrs: { "aria-hidden": "true" } },
                [_c("use", { attrs: { "xlink:href": _vm.iconName } })]
              ),
            ]
          )
        : _c("svg", { class: _vm.svgClass, attrs: { "aria-hidden": "true" } }, [
            _c("use", { attrs: { "xlink:href": _vm.iconName } }),
          ]),
      _c("span", { staticClass: "svg-icon" }, [_vm._t("default")], 2),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }